import { Locale, type LocalizedString } from "../Locale.js";
import type { Tenant } from "../Tenant.js";
import { getPathInLocale } from "./getPathInLocale.js";

export function getProductionPath(tenant: Tenant): string {
	const pathMap: LocalizedString = {
		[Locale.cs]: "/odvetvi/vyroba",
		[Locale.en]: "/industries/production",
	};

	return getPathInLocale(tenant.locale, pathMap);
}
